import { Box, BoxProps, Button, ColorOptions, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import MangeUserIntroIcon from '../../../assets/images/svg/MangeUserIntroIcon'
import { Routes } from '../../../nav/routes'
import { Colors } from '../../../util/util'

const Intro = () => {
  const navigation = useNavigation()
  return (
    <Box flex={1} backgroundColor="SECONDARY">
      <ModBox f={1}>
        <Spacer size={70} direction="vertical" />
        <Box flex={1} align={'center'} justifyContent="center">
          <MangeUserIntroIcon />
        </Box>
        <Box flex={1} {...styles.listWrapper} justifyContent={'space-between'}>
          <Box width={'85%'}>
            <ModBox>
              <Spacer size={10} direction="vertical" />
              <Text color={Colors.BLACK_14 as ColorOptions} lineHeight={30} fontSize={24} fontFamily="JioType-Black">
                Add staff and allow them to manage customer payments and more
              </Text>
              <Spacer size={10} direction="vertical" />
              <Text color={Colors.PRIMARY_GREY as ColorOptions} fontSize={14} fontFamily="JioType-Medium">
                Your staff will receive payment notifications and their access can be removed at any time.
              </Text>
              <Spacer size={20} direction="vertical" />
            </ModBox>
          </Box>
          <Button
            isFull
            isRound
            testID="intro"
            onPress={() => {
              navigation?.navigate(Routes.USER_MANAGEMENT.VIEW_USERS as never)
            }}
            color={Colors.PRIMARY}
            underlayColor={'TRANSPARENT'}
            height={48}>
            <Text color="WHITE" fontSize={16} fontFamily="JioType-Bold">
              Continue
            </Text>
          </Button>
        </Box>
      </ModBox>
    </Box>
  )
}

const styles = {
  listWrapper: {
    backgroundColor: 'WHITE',
    padding: 25,
    paddingTop: 35,
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    width: '100%',
    height: '100%',
    zIndex: 4,
    overflow: 'auto',
  } as BoxProps,
}

export default Intro
